import { render, staticRenderFns } from "./StudentsByAccommodation.vue?vue&type=template&id=d6a4a480&scoped=true&"
import script from "./StudentsByAccommodation.vue?vue&type=script&lang=js&"
export * from "./StudentsByAccommodation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a4a480",
  null
  
)

export default component.exports